<template>
  <BModal :id="id" v-model="modalOpen" class="modal-info" :no-footer="hideFooter" @update:model-value="closeModal">
    <template #title>
      <slot :data="data" name="modal-title" />
    </template>
    <slot :data="data" />
    <template #footer>
      <slot :data="data" :close-modal="closeModal" name="modal-footer" />
    </template>
  </BModal>
</template>

<script lang="ts">
import { BModal } from 'bootstrap-vue-next'
import { computed, defineComponent, onMounted, ref, watch, type ComputedRef, type Ref } from 'vue'
import { useVueNextModalStore } from '@/store/vueNextModal'

export default defineComponent({
  name: 'ModalWrap',
  components: { BModal },
  props: {
    name: {
      type: String,
      required: true,
    },
    hideFooter: {
      type: Boolean,
      default: true,
    },
    id: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const modalStore = useVueNextModalStore()
    const data: ComputedRef = computed(() => modalStore.modalProps)
    const modalOpen: Ref<boolean> = ref(false)
    const modalOpened: ComputedRef<boolean> = computed(() => modalStore.isModalVisible(props.name))

    const closeModal = () => {
      modalStore.closeModal(props.name)
    }

    onMounted(() => {
      modalOpen.value = modalStore.isModalVisible(props.name)
    })
    watch(modalOpened, (newValue) => {
      modalOpen.value = newValue
    })

    return { data, modalOpen, closeModal }
  },
})
</script>
